import { useEffect, useState } from "react";
import { func } from "prop-types";
import { useTranslation } from "react-i18next";
import { PriceFormats } from "@repo/utils";
import { COMPANY_SETTINGS } from "@client";
import { getCompanySettingsQuery, setCompanySettingsQuery } from "@query";
import { InfoLabel, Radio } from "@components";
import Grid from "@material-ui/core/Grid";

export const PriceFormatSetter = ({
  onChange,
}) => {
  const { t } = useTranslation();
  
  const [ priceFormat, setPriceFormat ] = useState(null);
  
  useEffect(() => {
    (async () => {
      let u = await getCompanySettingsQuery(COMPANY_SETTINGS.PRICE_FORMAT_DEF);
      setPriceFormat(u || PriceFormats.EUROPEAN);
      onChange?.(u || PriceFormats.EUROPEAN);
    })();
  }, []);
  
  const handlePriceFormatChange = (e) => {
    const v = Number(e.target.value);
    setPriceFormat(v);
    onChange?.(v);
    setCompanySettingsQuery(COMPANY_SETTINGS.PRICE_FORMAT_DEF, v);
  };
  
  return (
    <Grid item container direction="column" wrap="nowrap" spacing={1} className="mb-4">
      <InfoLabel
        className="my-0"
        label="views.editor.dialogs.price_settings.format"
      />
      <Grid item xs={ 12 }>
        <Radio
          name="price-format"
          aria-label="price-format"
          value={PriceFormats.EUROPEAN}
          checked={priceFormat === PriceFormats.EUROPEAN}
          onChange={handlePriceFormatChange}
          className="mr-2"
          labelClassName="m-0"
          label={<>
            <span>
              {t("views.editor.dialogs.price_settings.formats.european")}
            </span>
            <span className="color-section ml-1">
              {t("views.editor.dialogs.price_settings.formats.european_eg")}
            </span>
          </>}
        />
      </Grid>
      <Grid item xs={ 12 }>
        <Radio
          name="price-format"
          aria-label="price-format"
          value={PriceFormats.AMERICAN}
          checked={priceFormat === PriceFormats.AMERICAN}
          onChange={handlePriceFormatChange}
          className="mr-2"
          labelClassName="m-0"
          label={<>
            <span>
              {t("views.editor.dialogs.price_settings.formats.american")}
            </span>
            <span className="color-section ml-1">
              {t("views.editor.dialogs.price_settings.formats.american_eg")}
            </span>
          </>}
        />
      </Grid>
    </Grid>
  )
}

PriceFormatSetter.propTypes = {
  onChange: func,
}